// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.article-sub-header{background:#fff;display:flex;height:85px;justify-content:space-between;left:0;position:fixed;top:0;width:100%;z-index:11}@media(min-width:1100px){.scroll-progress__rail{top:80px!important}}.article-sub-header__title{font-size:20px;font-weight:800}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
